if (!customElements.get('addon-products')) {
    class AddonProducts extends HTMLElement {
        constructor() {
            super();
            this.handleClick = this.handleClick.bind(this);
            this.handleChange = this.handleChange.bind(this);
            this.handleDocumentClick = this.handleDocumentClick.bind(this);
        }

        connectedCallback() {
            this.addEventListener('click', this.handleClick);
            this.addEventListener('change', this.handleChange);
            document.addEventListener('click', this.handleDocumentClick);
            this.updateTotal();
        }

        disconnectedCallback() {
            this.removeEventListener('click', this.handleClick);
            this.removeEventListener('change', this.handleChange);
            document.removeEventListener('click', this.handleDocumentClick);
        }

        handleClick(evt) {
            const toggle = evt.target.closest('.addon-toggle');
            if (!toggle || !this.contains(toggle)) return;

            evt.stopPropagation();
            const group = toggle.closest('.addon-group');
            const dropdown = group ? group.querySelector('.addon-dropdown') : null;
            if (!dropdown) return;

            const isOpen = dropdown.classList.contains('open');
            this.closeAll();
            if (!isOpen) dropdown.classList.add('open');
        }

        handleChange(evt) {
            if (!evt.target.matches('[data-addon-input]')) return;
            this.updateTotal();
        }

        handleDocumentClick(evt) {
            if (this.contains(evt.target)) return;
            this.closeAll();
        }

        closeAll() {
            this.querySelectorAll('.addon-dropdown').forEach((dropdown) => {
                dropdown.classList.remove('open');
            });
        }

        updateTotal() {
            const currency = this.dataset.currency || 'AED';
            const decimals = currency === 'AED' ? 2 : 3;

            const total = Array.from(this.querySelectorAll('[data-addon-input]:checked'))
                .reduce((sum, input) => sum + parseFloat(input.dataset.price || 0), 0);

            const totalBox = this.querySelector('[data-addon-total]');
            const totalValue = this.querySelector('[data-addon-total-value]');

            if (!totalBox || !totalValue) return;

            totalBox.style.display = total > 0 ? 'block' : 'none';
            if (total > 0) totalValue.textContent = `${currency} ${total.toFixed(decimals)}`;
        }

        /**
         * Returns the currently selected add-on variants, formatted for the
         * Cart API's multi-item add payload.
         * @returns {Array<{id: number, quantity: number}>}
         */
        getSelectedItems() {
            return Array.from(this.querySelectorAll('[data-addon-input]:checked'))
                .map((input) => ({ id: parseInt(input.value, 10), quantity: 1 }))
                .filter((item) => !Number.isNaN(item.id));
        }
    }

    customElements.define('addon-products', AddonProducts);
}